<template>
 
  <div class="more-comments-btns-blck">
    <div v-for="index in parseInt(totalClusters/commentClusterPerPage) + coeff(totalClusters, commentClusterPerPage)" :key="index">
      <div v-if="commentPageNum == index-1">
             <picture>
               <source srcset="./../assets/icons/comments-btns-center.webp" type="image/webp">
               <source srcset="./../assets/icons/comments-btns-center.png" type="image/jpeg"> 
               <img src="./../assets/icons/comments-btns-center.png" width="50" height="50" alt="You are here" title="You are here" loading="lazy"/>
             </picture>
      </div> 
      <div v-else-if="(commentsLastBtn(postId,index,totalClusters,commentClusterPerPage) 
                      && commentPageNum >= index - btnsDeepToShow 
                      && commentPageNum < index - 1 + btnsDeepToShow)
                      || ((commentPageNum + btnsDeepToShow) > (totalClusters/commentClusterPerPage - 1)
                      && (commentPageNum - btnsDeepToShow) > (totalClusters/commentClusterPerPage - 1))
                      || (index-1 == totalClusters/commentClusterPerPage
                      && commentPageNum + btnsDeepToShow > totalClusters/commentClusterPerPage)
                      ">

        <a v-if="(index-1)!=0" class="comments-btns-link" :href="'../reviews/?p='+postId+'&n='+(index-1)"><div class="comments-btns">{{index-1}}</div></a>  
        <a v-if="(index-1)==0" class="comments-btns-link" :href="'../reviews/?p='+postId"><div class="comments-btns comments-btns-left-arrow"></div></a>  
        
      </div>
      <div v-else-if="index == 1" class="comments-btns-left-arrow-wrapper">

             <a class="comments-btns-link" :href="'../reviews/?p='+postId"><div class="comments-btns comments-btns-left-arrow"></div></a>
             <div class="comments-btns-dots"></div>
             <div class="comments-btns-dots"></div>
             <div class="comments-btns-dots"></div>

      </div>

    </div>
      <div v-if="commentPageNum < (totalClusters/commentClusterPerPage - 1)" class="comments-btns-right-arrow-wrapper">
             <div class="comments-btns-dots"></div>
             <div class="comments-btns-dots"></div>
             <div class="comments-btns-dots"></div>
             <a class="comments-btns-link" :href="'../reviews/?p='+postId+'&n='+(commentPageNum+1)"><div class="comments-btns comments-btns-right-arrow"></div></a>
      </div>
  

</div>
  <div class="comments-btns-txt">more comments, questions and answers</div>

</template>

<script>

export default {
  name: "MoreCommentsButtons",
  props: ['post_id', 'total_comments', 'total_clusters', 'cluster_perpage','pageNum'],
  data() {
    return {
      btnsDeepToShow: 4,    //3 btns before and after this page
      postId: this.post_id,
      totalComments: this.total_comments,
      totalClusters: this.total_clusters,
      commentClusterPerPage: this.cluster_perpage,
      commentPageNum: parseInt(this.pageNum)
    };
  },
  setup(){
    

    return {
         
    }
  },
  methods: {
     commentsLastBtn: (postId, index,totalClusters,commentClusterPerPage) => {
      //console.log(index)
        if(totalClusters/commentClusterPerPage % 1 === 0){
           if(index-1 == totalClusters/commentClusterPerPage){
              return false
           }
           else{
              return true
           }
        }
        else{
           if(index <= parseInt(totalClusters/commentClusterPerPage) + 1){
             //console.log('true')
             return true
           }
           else{
            //console.log('false')
            return false
           }
           
        }

     },
     coeff: (t, c) => {
         if(t/c % 1 === 0){
            return parseInt('0')
         }
         else{
            return parseInt('2')
         }
     }
  }    


}
</script>

<style scoped>
.more-comments-blck{
  margin-top:20px;
}
.more-comments-btns-blck{
  display:flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}
.comments-btns{
  width:calc(6px + 1.9vw + 1.9vh);
  height:calc(6px + 1.9vw + 1.9vh);
  border-radius:50%;
  background-color:indigo;
  color:#ffffff;
  font-size:calc(6px + 0.6vw + 0.6vh);
  margin-left:6px;
  display:flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto";
}
.comments-btns:hover{
  background-color:#4f666a;
}
.comments-btns-link{
  text-decoration: none;
}
.comments-btns-left-arrow{
  background-image: url('./../assets/icons/comments-btn-home.png');
  background-image: -webkit-image-set(url('./../assets/icons/comments-btn-home.webp') 1x);
  background-repeat: no-repeat;
  background-position: center;
}
.comments-btns-right-arrow{
  background-image: url('./../assets/icons/comments-btns-right-arrow.png');
  background-image: -webkit-image-set(url('./../assets/icons/comments-btns-right-arrow.webp') 1x);
  background-repeat: no-repeat;
  background-position: center;
}
.comments-btns-left-arrow-wrapper,.comments-btns-right-arrow-wrapper{
  display:flex;
  align-items: baseline;
}
.comments-btns-dots{
  width:2px;
  height:2px;
  border-radius:50%;
  background-color:indigo;
  border:1px solid indigo;
  margin-left:3px;
}
.comments-btns-txt{
  width:100%;
  text-align:center;
  font-size:calc(4px + 0.7vw + 0.7vh);
  color:#e66d29;
  font-family: "Roboto";
}
</style>
